export const AREA_TYPES = [
  { value: 'DA', label: 'Dwell Analysis' },
  { value: 'OT', label: 'Outside Traffic' },
  { value: 'AI', label: 'Areas Of Interest' },
  { value: 'SE', label: 'Store Entrance' },
];
